import "../sass/main.scss";
import { start } from "./app";
import { getSessionId } from "./utils";

console.log("Booting 🇧🇷");

// Get the session id
const sessionId = getSessionId();

// Start the app
start(sessionId);
